import React from 'react'

export default ({ children }) => <div className="video-row">{children}</div>



// WEBPACK FOOTER //
// ./src/components/partials/video-row.js